import React, { useEffect, useState } from "react";
import { PaymentStatusStyled } from "./styled";
import {
  ArrowRight2,
  FailedIcon,
  PagesBg,
  Phone,
  SuccessIcon,
} from "../../components/Styled/AllImages";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import {
  Box,
  HeadingStyled,
  SubHeadingStyled,
  TextStyled,
} from "../../components/Styled/Elements";
import {
  ButtonWithIcon,
  ContactButton,
} from "../../components/Styled/CustomElements";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  useCheckStatusMutation,
  useCheckTabbyStatusMutation,
  useCreateSessionMutation,
  useCreateTabbySessionMutation,
  useDownloadFileMutation,
} from "../../store/services/checkoutApi";
import axios from "axios";
import { toast } from "react-toastify";

const TabbyPaymentStatus = () => {
  const PACKAGE_ASSET_URL = process.env.REACT_APP_PACKAGE_ASSET_URL;
  const [orderData, setOrderData] = useState({});

  const { status } = useParams();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("payment_id");
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [
    checkTabbyStatus,
    { data: tabbyData, isLoading: isTabbyLoading, isTabbySuccess },
  ] = useCheckTabbyStatusMutation();

  const [trigger, { isLoading: isTabbyCheckoutLoading }] =
    useCreateTabbySessionMutation();
  const [
    triggerDownload,
    {
      data: downloadData,
      isLoading: isFileLoading,
      isFetching: isFileFetching,
      isError: isFileError,
      refetch,
    },
  ] = useDownloadFileMutation();

  const WhatsApp = (num) => {
    const phoneNumber = `+${num}`;
    const message = "Hello, Own Your Health";
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappURL, "_blank");
  };

  const handleAttachment = async () => {
    if (orderData) {
      const { data } = await triggerDownload({
        lang: language,
        fileName: orderData?.package?.plan,
      });

      const blobURL = window.URL.createObjectURL(data);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = blobURL;
      a.download = orderData?.package?.plan;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(blobURL);
      document.body.removeChild(a);
    }
  };

  const tryCheckout = async () => {
    const orderData = localStorage.getItem("order_data");
    try {
      const { data, error } = await trigger({
        lang: language,
        data: JSON.parse(orderData),
      });

      if (error) {
        // Handle any errors that occurred during the request
        console.error("Error:", error);
        toast.error(error?.data?.message);
      } else if (data) {
        localStorage.setItem(
          "order_info",
          JSON.stringify({
            tabby_order_id: data?.data?.order?.tabby_order_id,
            order_id: data?.data?.order.order_id,
          })
        );

        const checkoutUrl = data?.data?.redirect_url;
        if (checkoutUrl) {
          localStorage.setItem("order_data", orderData);
          window.location.href = checkoutUrl;
        }
      } else if (data?.message) {
        toast.error(data?.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("order_info")) {
      const orderInfo = JSON.parse(localStorage.getItem("order_info"));
      checkTabbyStatus({
        lang: language,
        data: {
          payment_id: paymentId,
          ...orderInfo,
        },
      });
    }
  }, []);
  useEffect(() => {
    if (paymentId && tabbyData) {
      setOrderData(tabbyData?.data);
      localStorage.removeItem("order_info");
    }
  }, [tabbyData]);
  return (
    <PaymentStatusStyled
      className="innerPagesBg"
      // style={{ backgroundImage: `url(${PagesBg})` }}
    >
      <Container className="common-container">
        {isTabbyLoading ? (
          <Box className="d-flex justify-content-center">
            <Spinner animation="border" className="custom-spinner" />
          </Box>
        ) : (
          <Box className="d-flex justify-content-center">
            <Box>
              <Box className="d-flex align-items-center justify-content-center">
                {status === "cancel" ? (
                  <>
                    <SuccessIcon className="mx-3" />
                    <HeadingStyled size="36px" color="var(--dangerColor)">
                      {t("payment_cancelled")}
                    </HeadingStyled>
                  </>
                ) : (
                  <>
                    <FailedIcon className="mx-3" />
                    <HeadingStyled size="36px" color="var(--dangerColor)">
                      {t("payment_failed")}
                    </HeadingStyled>
                  </>
                )}
              </Box>
              <Box>
                <SubHeadingStyled
                  size="20px"
                  weight="400"
                  color="var(--themeColor)"
                  className="my-3"
                >
                  {status === "cancel"
                    ? t("you_aborted_the_payment")
                    : t("unable_to_approve_purchase")}
                </SubHeadingStyled>
              </Box>
              <Box className="payment-info-card mt-5 p-5">
                <Row className="flex-nowrap">
                  <Col
                    lg={5}
                    md={6}
                    sm={6}
                    className="flex-shrink-1 custom-col"
                  >
                    {orderData?.package_name && (
                      <SubHeadingStyled
                        size="16px"
                        weight="500"
                        className="mb-2"
                        color="var(--white)"
                      >
                        {t("package_name")}
                      </SubHeadingStyled>
                    )}
                  </Col>
                  <Col lg={7} md={6} sm={6} className="custom-col">
                    {orderData?.package_name && (
                      <TextStyled
                        size="16px"
                        className="mb-2"
                        color="var(--white)"
                      >
                        {orderData?.package_name}
                      </TextStyled>
                    )}
                  </Col>
                </Row>
                <Row className="flex-nowrap">
                  <Col
                    lg={5}
                    md={6}
                    sm={6}
                    className="flex-shrink-1 custom-col"
                  >
                    {orderData?.product_name && (
                      <SubHeadingStyled
                        size="16px"
                        weight="500"
                        className="mb-2"
                        color="var(--white)"
                      >
                        {t("product_name")}
                      </SubHeadingStyled>
                    )}
                  </Col>
                  <Col lg={7} md={6} sm={6} className="custom-col">
                    {orderData?.product_name && (
                      <TextStyled
                        size="16px"
                        className="mb-2"
                        color="var(--white)"
                      >
                        {orderData?.product_name}
                      </TextStyled>
                    )}
                  </Col>
                </Row>
                <Row className="flex-nowrap">
                  <Col
                    lg={5}
                    md={6}
                    sm={6}
                    className="flex-shrink-1 custom-col"
                  >
                    <SubHeadingStyled
                      size="16px"
                      weight="500"
                      className="mb-2"
                      color="var(--white)"
                    >
                      {t("tax")}
                    </SubHeadingStyled>
                  </Col>
                  <Col lg={7} md={6} sm={6} className="custom-col">
                    <TextStyled
                      size="16px"
                      className="mb-2"
                      color="var(--white)"
                    >
                      {orderData?.vat_percentage} %
                    </TextStyled>
                  </Col>
                </Row>
                <Row className="flex-nowrap">
                  <Col
                    lg={5}
                    md={6}
                    sm={6}
                    className="flex-shrink-1 custom-col"
                  >
                    <SubHeadingStyled
                      size="16px"
                      weight="500"
                      className="mb-2"
                      color="var(--white)"
                    >
                      {t("total_amount")}
                    </SubHeadingStyled>
                  </Col>
                  <Col lg={7} md={6} sm={6} className="custom-col">
                    <TextStyled
                      size="16px"
                      className="mb-2"
                      color="var(--white)"
                    >
                      {orderData?.grand_total} {t("sar")}
                    </TextStyled>
                  </Col>
                </Row>
                <Row className="flex-nowrap">
                  <Col
                    lg={5}
                    md={6}
                    sm={6}
                    className="flex-shrink-1 custom-col"
                  >
                    <SubHeadingStyled
                      size="16px"
                      weight="500"
                      className="mb-2"
                      color="var(--white)"
                    >
                      {t("payment")}
                    </SubHeadingStyled>
                  </Col>
                  <Col lg={7} md={6} sm={6} className="custom-col">
                    <TextStyled
                      size="16px"
                      className="mb-2"
                      color={"var(--dangerColor)"}
                    >
                      {status === "cancel" ? t("cancelled") : t("failed")}
                    </TextStyled>
                  </Col>
                </Row>
                <Box className="d-flex justify-content-center mt-3">
                  <ContactButton
                    icon={ArrowRight2}
                    label={t("try_again")}
                    onClick={tryCheckout}
                    isLoading={isTabbyCheckoutLoading}
                  />
                </Box>
              </Box>
              <Box className="d-flex justify-content-center my-5">
                <Link className="home-btn" to={"/"}>
                  {t("back_to_home")} <ArrowRight2 className="mx-2" />
                </Link>
              </Box>
            </Box>
          </Box>
        )}
      </Container>
    </PaymentStatusStyled>
  );
};

export default TabbyPaymentStatus;
